import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export { default as Alert } from "./Alert.vue";
export { default as AlertDescription } from "./AlertDescription.vue";
export { default as AlertTitle } from "./AlertTitle.vue";

// Edited from shadcn-vue: tinted status variants over the theme's status
// tokens. The body stays foreground so it is legible on the dark admin
// background; the colour is carried by the border, the tint and the icon.
export const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        info: "border-info/40 bg-info/5 text-foreground [&>svg]:text-info",
        success: "border-success/40 bg-success/5 text-foreground [&>svg]:text-success",
        warning: "border-warning-fill/40 bg-warning-fill/5 text-foreground [&>svg]:text-warning",
        destructive: "border-destructive/60 bg-destructive/10 text-foreground [&>svg]:text-danger",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
export type AlertVariants = VariantProps<typeof alertVariants>;
